<template>
    <HeaderView></HeaderView>
     <router-view :style="{'min-height': windowH}"></router-view>

    <FooterView></FooterView>
</template>

<script>
    import HeaderView from '@/components/HeaderView.vue'
     import FooterView from '@/components/FooterView.vue'


    export default {
        name: "Index",
        components: {
            HeaderView,
            FooterView,
         },
        data() {
            return {
                url: process.env.VUE_APP_DOMAIN,
                windowH:null

            }
        },
        created() {
            window.addEventListener('resize', this.windowHeight);
            this.windowHeight();
        },
        methods: {

            windowHeight(){
                this.windowH =`${document.documentElement.clientHeight - 304}` + "px";
            }
        }
    }
</script>

<style scoped>

</style>